import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Box, Typography, Divider, Button } from "@material-ui/core";
import {
  CaretCircleDown,
  CaretCircleUp,
  CheckSquareOffset,
  Info,
} from "phosphor-react";
import { fget } from "../../../../API/callsAPI";
import TaskToDos from "../../TaskToDos/TaskToDos";
import useStyles from "./ReviewAgentTask.styles";
import PriorityViewer from "../../PriorityViewer/PriorityViewer.component";
import StatusDropDown from "../../StatusDropDown/StatusDropDown.component";
import UsersViewer from "../../UsersViewer/UsersViewer";

export default function ReviewAgentTask({
  linkedTask,
  selectedVersion,
  projectId,
  taskStatusList,
  updateLinkedTaskAndComments,
  version_type,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [showTaskDetail, setShowTaskDetails] = useState(false);
  const [checkList, setCheckList] = useState([]);
  const [refreshCheckList, setRefreshCheckList] = useState(0);
  const [currentTab, setCurrentTab] = useState("active");
  const [isDataLoading, setDataLoading] = useState(false);

  const handleTaskDetail = () => {
    setShowTaskDetails(!showTaskDetail);
  };

  const getChecklist = async (loader) => {
    try {
      loader && setDataLoading(true);
      const res = await fget({
        url: `trackables/checklist/?project=${projectId}&taskId=${
          linkedTask.id
        }&completed=${currentTab === "active" ? "False" : "True"}`,
      });
      if (res.data.results) {
        setCheckList(res.data.results[0]);
      }
      setDataLoading(false);
    } catch (error) {
      console.log(error);
      setDataLoading(false);
    }
  };

  const updateRefreshChecklist = () => {
    setRefreshCheckList(refreshCheckList + 1);
  };

  useEffect(() => {
    if (linkedTask.id) {
      getChecklist("");
    }
  }, [refreshCheckList]);

  useEffect(() => {
    if (linkedTask.id) {
      getChecklist("loader");
    }
  }, [linkedTask, currentTab]);

  return (
    <Box className={classes.root}>
      {/* <div className={classes.spaceBetween}>
        <div className={`${classes.header} ${classes.tertiaryColor}`}>
          <Info size={20} /> Task Details
        </div>
        <Typography className={classes.heading}>{linkedTask.name}</Typography>
        <Button
          onClick={() => {
            if (selectedVersion.asset) {
              history.push(
                `/${projectId}/assets/${selectedVersion.asset.id}/task`
              );
            } else if (selectedVersion.shot) {
              history.push(
                `/${projectId}/sequence/${selectedVersion.shot.parent_sequence}/shots/${selectedVersion.shot.id}/task`
              );
            }
          }}
          startIcon={<CheckSquareOffset size={20} />}
        >
          Go to Task
        </Button>
      </div> */}
      {/* {showTaskDetail && linkedTask?.id !== undefined && (
        <div style={{ width: "100%", height: "27%" }}>
          <div className={classes.dateAndPriority}>
            <div className={classes.flexColumn}>
              <span className={classes.date}>
                {new Intl.DateTimeFormat("en-US", {
                  day: "2-digit",
                  month: "short",
                }).format(new Date(linkedTask?.start_time))}{" "}
                -{" "}
                {new Intl.DateTimeFormat("en-US", {
                  day: "2-digit",
                  month: "short",
                }).format(new Date(linkedTask?.end_time))}
              </span>
              <div className={classes.fieldName}>Duration</div>
            </div>
            <div className={classes.flexColumn}>
              <PriorityViewer priority={linkedTask?.priority} />
              <div className={classes.fieldName}>Priority</div>
            </div>
          </div>
          <div className={classes.statusContainer}>
            <StatusDropDown
              statusList={taskStatusList}
              currStatus={linkedTask?.status}
              updateRefreshCounter={updateLinkedTaskAndComments}
              url={`trackables/task/${linkedTask?.id}/`}
            />
            <div className={classes.fieldName}>Status</div>
          </div>
          <div className={classes.userAndDepartment}>
            <div className={classes.flexColumn}>
              <UsersViewer
                assignedUser={linkedTask?.assigned_users}
                selectedTask={linkedTask}
                editable="no"
              />
              <div className={classes.fieldName}>Users</div>
            </div>
            <div className={classes.flexColumn}>
              <div>{linkedTask?.department?.name}</div>
              <div className={classes.fieldName}>Department</div>
            </div>
          </div>
        </div>
      )} */}
      {/* <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <div style={{ width: "48%", borderBottom: "1px solid #6C65D9" }} />
        <Button
          style={{ minWidth: "0px !important", padding: "1px" }}
          onClick={handleTaskDetail}
        >
          {showTaskDetail ? (
            <CaretCircleUp color="#6C65D9" size={36} />
          ) : (
            <CaretCircleDown color="#6C65D9" size={36} />
          )}
        </Button>
        <div style={{ width: "48%", borderBottom: "1px solid #6C65D9" }} />
      </div> */}
      <Typography style={{ fontSize: "18px !important", marginBottom: "8px" }}>
        Task To-Do's
      </Typography>
      <div style={{ width: "100%", height: showTaskDetail ? "40%" : "80%" }}>
        <TaskToDos
          currentTab={currentTab}
          onChangeTab={setCurrentTab}
          linkedTask={linkedTask}
          selectedVersion={selectedVersion}
          updateRefreshChecklist={updateRefreshChecklist}
          checkList={checkList}
          version_type={version_type}
          isDataLoading={isDataLoading}
          toDoType="versionVeiwer"
          projectId={projectId}
        />
      </div>
    </Box>
  );
}
